var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _path8, _ellipse, _ellipse2, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragonBody(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 5.06421L21.5 8.56421C22.1667 9.23088 24.2373 10.1956 26.5 9.06421C27.8427 8.39286 27.5 6.56421 27 5.06421Z",
    fill: "#D2421F",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94238 5.06421L9.44238 8.56421C8.77572 9.23088 6.70512 10.1956 4.44238 9.06421C3.09969 8.39286 3.44238 6.56421 3.94238 5.06421Z",
    fill: "#D2421F",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3.0642C8.5 3.4642 10.6667 6.23087 11.5 7.5642L13 7.06421C12.5 6.39754 11.4 4.86421 11 4.06421C10.6 3.26421 11.8333 2.73088 12.5 2.56421L11 1.0642C10.6 0.664204 9.83333 2.23087 9.5 3.0642C9.5 2.6642 8.16667 1.89754 7.5 1.5642L6.5 3.0642Z",
    fill: "#FFB163",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3.0642C23 3.4642 20.8333 6.23087 20 7.5642L18.5 7.06421C19 6.39754 20.1 4.86421 20.5 4.06421C20.9 3.26421 19.6667 2.73088 19 2.56421L20.5 1.0642C20.9 0.664204 21.6667 2.23087 22 3.0642C22 2.6642 23.3333 1.89754 24 1.5642L25 3.0642Z",
    fill: "#FFB163",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.5642C24.2 7.76421 18.5 6.06421 16 6.06421C11 6.06421 6 9.06421 6 12.5642C6 16.0642 4.5 16.5642 4.5 19.5642C4.5 22.5642 9.5 25.5642 16 25.5642C22.5 25.5642 26.5 21.5642 26.5 19.5642C26.5 17.5642 26 18.5642 25 12.5642Z",
    fill: "#D2421F",
    stroke: "black",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25.064C21.1226 25.064 26 21.8156 26 19.9415C26 18.0673 25.5 18.064 25.4903 17.5988C23.5 15.5641 18 15.5641 15.9773 17.5988C12.5409 15.7246 7.5 15.564 5.5 17.564C5.26654 18.2032 5 18.064 5 19.9415C5 22.564 10.5 25.064 16 25.064Z",
    fill: "#FFA995"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 14.5642,
    r: 1,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 14.5642,
    r: 1,
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19.0642C12.8333 18.8975 12.2 18.5642 11 18.5642C9.5 18.5642 6 20.5642 4.5 20.5642C3.3 20.5642 1.66667 18.5642 1 17.5642",
    stroke: "black",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 19.0642C18.6667 18.8975 19.3 18.5642 20.5 18.5642C22 18.5642 25.5 20.5642 27 20.5642C28.2 20.5642 29.8333 18.5642 30.5 17.5642",
    stroke: "black",
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.5,
    cy: 17.0642,
    rx: 1.5,
    ry: 0.5,
    fill: "#FFEAE5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22,
    cy: 17.0642,
    rx: 1.5,
    ry: 0.5,
    fill: "#FFEAE5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 22.5C12.1667 23.5 16.6 24.9 21 22.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3 29C3 27.5455 4.63333 23.2576 5 22.5C6.32 23.8636 11.1 26 15.5 26C20.8836 26 23.5 24.1364 25.5 22.5C26.38 23.5909 28.5 28.0909 28.5 29H3Z",
    fill: "#D2421F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3 28.5C3 26.9 4.58333 22.8333 5 22C6.5 23.5 10.5 25.5 15.5 25.5C21.6178 25.5 23 23.5 25.5 22C26.5 23.2 28.5 27.5 28.5 28.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11 29C12.5873 27.4908 16.8095 25.3778 21 29H11Z",
    fill: "#FFE8A3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11 28.5001C13.5 26.5 18 26.4999 21 28.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragonBody);
export default __webpack_public_path__ + "static/media/dragon-body.b0e48592c3e6b4969cd1d4c90dd37503.svg";
export { ForwardRef as ReactComponent };